import type { Maybe } from '@adornis/base/utilTypes.js';
import type { ContractSupplementApplyHistoryForPath } from '../entities/AppliedContract.js';
import { getReadableChangeText } from './changePresentation.js';

/**
 * Maps the history of a path to human readable strings, i.e. for the history chain of a FormGridEntry.
 */
export const getReadableHistoryStrings = (
  history: Maybe<ContractSupplementApplyHistoryForPath>,
): string[] | undefined => {
  if (!history?.changes?.length) return undefined;

  return history.changes.map(change => getReadableChangeText(change));
};
